import { Action, Reducer } from "redux";
import { PartBrandState, PartBrandTypes, PartBrandActionTypes } from "./partBrandTypes";

export const INITIAL_STATE: PartBrandState = {
	tireBrand: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const partBrandReducer: Reducer<PartBrandState> = (state: PartBrandState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as PartBrandActionTypes;
	switch (actionTypes.type) {
		case PartBrandTypes.GET_TIRE_BRAND:
			return {
				...state,
				tireBrand: { ...state.tireBrand, isLoading: true },
			};

		case PartBrandTypes.SAVE_TIRE_BRAND:
			return {
				...state,
				tireBrand: {
					...state.tireBrand,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};

		default:
			return state;
	}
};

export default partBrandReducer;
